import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import Image from '../../assets/images/thankyou.svg';
import FullWidth from '../../components/basic/FullWidth';

class ThankYou extends Component {
    state = {  }
    render() { 
        return ( 
            <FullWidth SectionClass="thankyou-wrapper pb-100">
                <div className="white-wrapper">
                <div className="Thk-product">
                    <h2>Thank You</h2>
                    <p>Your Order Placed</p>
                    <img src={Image} alt="wild harbour" className="img-fluid"/>
                    
                </div>

                <div className="more-details">
                    <p>You can manage your orders in your profile page my orders menu</p>
                    <Link to="/my-account" className="ts-btn">MANAGE ORDERS</Link>
                    <div className="new-shopping">
                        <Link className="yellow-btn" to="/">CONTINUE SHOPPING</Link>
                    </div>
                </div>
                </div>
            </FullWidth>
         );
    }
}
 
export default ThankYou;